<script>
import Overlay from '@/assets/js/src/components/Overlay.vue'
import { mapActions, storeToRefs, getActivePinia, } from 'pinia'
import {
    ALPHABET_SORT,
    COLOR_SORT,
    USER_COUNT_SORT,
    DATE_SORT,
    CANONICAL_SORT,
    RELEVANCE_SORT,
} from '@/assets/js/src/util/uiTools'
import ButtonListGrid from '@/assets/js/src/components/ButtonListGrid.vue'
import { useTagListStore, } from '@/assets/js/src/modules/tag/_pinia/tagList'
import { useTagListApi, } from '@/assets/js/src/modules/tag/_composables/useTagListApi'
import { useUserStore, } from '@/assets/js/src/modules/user/_pinia/user'
import { useTagStore, } from '@/assets/js/src/modules/tag/_pinia/tag'
import LoadingDummyCustom from '@/assets/js/src/components/loading/LoadingDummyCustom'
import { useAppUiStore, } from '@/assets/js/src/pinia/appUi'
import colors from '@/assets/js/src/style/json/colors'
import H1Title from '@/assets/js/src/components/overlay/H1Title.vue'
import SearchFilter from '@/assets/js/src/components/forms/SearchFilter.vue'
import SwitchFilter from '@/assets/js/src/components/forms/SwitchFilter.vue'
import SortOptions from '@/assets/js/src/components/forms/SortOptions.vue'
import InfiniteScroll from '@/assets/js/src/components/core/InfiniteScroll'
import { useHeadInfoTitle, } from '@/assets/js/src/layout/useHeadInfo'
import { useTranslation, } from '@/assets/js/src/util/composables'
import { computed, } from 'vue'

export default {
    name: 'TagList',
    components: {
        InfiniteScroll,
        SortOptions,
        SwitchFilter,
        SearchFilter,
        H1Title,
        LoadingDummyCustom,
        ButtonListGrid,
        Overlay,
    },
    setup () {
        useHeadInfoTitle({ titleKey: 'async.tag.list.title', })

        const activePinia = getActivePinia()
        const {
            page,
            maxPages,
        } = storeToRefs(useTagListStore(activePinia))

        const {
            loggedIn,
        } = storeToRefs(useUserStore(activePinia))

        const {
            backToList,
        } = storeToRefs(useTagStore(activePinia))

        const {
            printing,
        } = storeToRefs(useAppUiStore(activePinia))

        const {
            messagesLoaded,
            asyncStatusLoaded,
            tags,
            debouncedSearch,
            my,
            componentIsActive,
            sort,
            gridView,
        } = useTagListApi()

        return {
            page,
            maxPages,
            loggedIn,
            backToList,
            printing,
            messagesLoaded,
            asyncStatusLoaded,
            tags,
            debouncedSearch,
            my,
            componentIsActive,
            sort,
            gridView,
            ...useTranslation(),
            colors,
            sortEnum: computed(() => {
                let sortOptions = [
                    USER_COUNT_SORT,
                    DATE_SORT,
                    ALPHABET_SORT,
                    CANONICAL_SORT,
                ]
                if (my.value) {
                    sortOptions.push(COLOR_SORT)
                }
                if (debouncedSearch.value.length !== 0) {
                    sortOptions.push(RELEVANCE_SORT)
                }

                return sortOptions
            }),
        }
    },
    data () {
        return {
            loadingNext: false,
            gridDummyCount: 50,
        }
    },
    computed: {
        randomTagWidth: function () {
            return new Array(this.gridDummyCount).fill(0).map(() => Math.floor((Math.random() * (121)) + 50) + 'px')
        },
    },
    methods: {
        ...mapActions(useTagListStore,[
            'getTags',
        ]),
        getColor: function (tag) {
            if (typeof tag.user_tags !== 'undefined') {
                let color = tag.user_tags[0].color
                if (typeof color !== 'undefined') {
                    return color
                }
            }

            return ''
        },
        getMoreResults () {
            if (this.page === this.maxPages) {
                return
            }

            this.loadingNext = true
            let next = this.page + 1
            let self = this
            this.getTags({ page: next, }).then(() => {
                self.loadingNext = false
                this.$bsa && this.$bsa.event({
                    eventCategory: 'load more',
                    eventAction: 'Tags nachladen',
                    eventLabel: next,
                })
            })
        },
    },
}
</script>

<template>
    <overlay
        class-name="tag-list"
    >
        <div class="d-flex mb-7">
            <h1-title title-key="async.tag.list.title" />

            <v-spacer></v-spacer>

            <button-list-grid
                :grid-view="gridView"
                @toggle="gridView = !gridView"
            />
        </div>

        <search-filter
            v-model="debouncedSearch"
            label-key="async.tag.list.filter_placeholder"
        />

        <div class="d-flex align-center mb-7">
            <switch-filter
                v-model="my"
                :disabled="!loggedIn"
                label-key="async.tag.list.only_my"
            />

            <v-spacer></v-spacer>

            <sort-options
                v-model="sort"
                :types="sortEnum"
            />
        </div>

        <transition-group
            v-if="!gridView"
            name="scale-trans"
            tag="div"
            class="d-flex flex-wrap tag-list"
        >
            <template
                v-for="(tag, index) in tags"
                :key="'list-item' + tag.id"
            >
                <router-link
                    :class="[{'first': index === 0}, 'tag-list-item', getColor(tag)]"
                    :to="my ? {path: `/tag/${encodeURIComponent(tag.key)}`, query: {filter:'my'}} : {path: `/tag/${encodeURIComponent(tag.key)}`}"
                    @click="backToList = true"
                >
                    {{ tag.key }}
                </router-link>
            </template>
        </transition-group>

        <transition-group
            v-if="gridView"
            name="scale-trans"
            tag="div"
            class="d-flex flex-wrap tag-grid"
        >
            <template
                v-for="tag in tags"
                :key="'grid-item' + tag.id"
            >
                <router-link
                    :to="my ? {path: `/tag/${encodeURIComponent(tag.key)}`, query: {filter:'my'}} : {path: `/tag/${encodeURIComponent(tag.key)}`}"
                    @click="backToList = true"
                >
                    <v-chip
                        :class="['tag-grid-item',getColor(tag)]"
                        label
                    >
                        {{ tag.key }}
                    </v-chip>
                </router-link>
            </template>
            <v-spacer
                key="spacer"
            ></v-spacer>
        </transition-group>

        <template
            v-if="page < maxPages && !printing && asyncStatusLoaded"
        >
            <loading-dummy-custom
                v-for="n in (gridView ? gridDummyCount : 10)"
                :key="'tag_dummy_' + n"
                :height="gridView ? '32px' : '24px'"
                :width="gridView ? randomTagWidth[n] : '100%'"
                :margin="gridView ? '4px' : '12px'"
            >
                <infinite-scroll
                    v-if="n === 1"
                    :handler="getMoreResults"
                    :should-handle="!loadingNext && componentIsActive"
                    :class="['layout', 'wrap', 'hidden-print-only',{'justify-space-between':gridView,}]"
                    style="margin: 4px -4px;"
                />
            </loading-dummy-custom>
            <v-spacer
                v-if="gridView"
            ></v-spacer>
        </template>

        <!-- NO TAGS NOTICE -->
        <template
            v-if="messagesLoaded"
        >
            <div
                v-if="tags.length === 0 && debouncedSearch.length !== 0"
                class="d-flex flex-wrap"
            >
                <p v-if="my">
                    {{ t('async.tag.list.no_my_items') }}
                </p>
                <p v-else>
                    {{ t('async.tag.list.no_filtered_items') }}
                </p>
            </div>
        </template>
    </overlay>
</template>

<style lang="scss">
.bs-app {
    .tag-list {
        p {
            color: map-deep-get($bs-color, greyDark);
        }

        a {
            text-decoration: none;
        }

        .tag-grid {
            display: flex;
            justify-content: space-between;
            margin: -4px;

            @media (max-width: #{map-deep-get($bs-xs, breakpointValue)}px) {
                justify-content: flex-start;
            }

            &-item {
                @each $color_name, $color_values in map-deep-get($bs-color, tag, map) {
                    &.#{$color_name} {
                        background: map-deep-get($color_values, "back");

                        .v-chip__content {
                            color: map-deep-get($color_values, "front");
                        }
                    }
                }

                background: var(--bs-color-tag-default-back);

                .v-chip__content {
                    color: var(--bs-color-tag-default-front);
                    cursor: pointer;
                }
            }
        }

        .tag-list {
            &-item {
                @each $color_name, $color_values in map-deep-get($bs-color, tag, map) {
                    &.#{$color_name} {
                        padding-left: 12px !important;
                        border-left: 4px solid map-deep-get($color_values, back);
                    }
                }

                display: flex;
                flex: 1 1 100%;
                padding: 12px 0 12px 16px;
                color: var(--bs-color-overlay-grey-dark);
                font-size: 16px;
                cursor: pointer;

                &:not(.first) {
                    border-top: 1px solid var(--bs-color-grey);
                }

                &:hover {
                    background-color: var(--bs-color-white);
                }
            }
        }

        .scale-trans {
            &-enter-from, &-leave-to {
                transform: scale(0);
                opacity: 0;
            }

            &-move {
                transition: transform .3s;
            }

            &-leave-active {
                position: absolute;
            }
        }
    }
}
</style>
